import { createElementVNode as _createElementVNode, vShow as _vShow, withDirectives as _withDirectives, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, vModelSelect as _vModelSelect, normalizeClass as _normalizeClass, createBlock as _createBlock, createCommentVNode as _createCommentVNode, vModelRadio as _vModelRadio, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-64cd34b6"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["innerHTML"]
const _hoisted_2 = { class: "text-end" }
const _hoisted_3 = { class: "text-danger font-weight-bold" }
const _hoisted_4 = { class: "row" }
const _hoisted_5 = { class: "col" }
const _hoisted_6 = { class: "row" }
const _hoisted_7 = { class: "col" }
const _hoisted_8 = { class: "form-group" }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "font-weight-bold" }, "Facility", -1))
const _hoisted_10 = ["disabled"]
const _hoisted_11 = ["value"]
const _hoisted_12 = {
  key: 1,
  class: "requiredTxt"
}
const _hoisted_13 = { class: "col" }
const _hoisted_14 = { class: "form-group" }
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "font-weight-bold" }, "Service Line", -1))
const _hoisted_16 = { class: "col" }
const _hoisted_17 = { class: "form-group" }
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "font-weight-bold" }, "Department", -1))
const _hoisted_19 = ["disabled"]
const _hoisted_20 = ["value"]
const _hoisted_21 = {
  key: 1,
  class: "requiredTxt"
}
const _hoisted_22 = { class: "row" }
const _hoisted_23 = { class: "col" }
const _hoisted_24 = { class: "form-group" }
const _hoisted_25 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "font-weight-bold" }, "Status", -1))
const _hoisted_26 = ["value"]
const _hoisted_27 = {
  key: 1,
  class: "requiredTxt"
}
const _hoisted_28 = { class: "col" }
const _hoisted_29 = { class: "form-group" }
const _hoisted_30 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "font-weight-bold" }, "Shift Code ", -1))
const _hoisted_31 = ["disabled"]
const _hoisted_32 = ["value"]
const _hoisted_33 = {
  key: 1,
  class: "requiredTxt"
}
const _hoisted_34 = { class: "col" }
const _hoisted_35 = { class: "form-group" }
const _hoisted_36 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "font-weight-bold" }, "Skill", -1))
const _hoisted_37 = ["disabled"]
const _hoisted_38 = ["value", "title"]
const _hoisted_39 = {
  key: 1,
  class: "requiredTxt"
}
const _hoisted_40 = { class: "invalid-msg" }
const _hoisted_41 = { class: "row" }
const _hoisted_42 = { class: "col" }
const _hoisted_43 = { class: "form-group" }
const _hoisted_44 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "font-weight-bold" }, "Date", -1))
const _hoisted_45 = { class: "col" }
const _hoisted_46 = { class: "row" }
const _hoisted_47 = { class: "col" }
const _hoisted_48 = { class: "form-group" }
const _hoisted_49 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "font-weight-bold" }, "Start Time", -1))
const _hoisted_50 = { class: "col" }
const _hoisted_51 = { class: "form-group" }
const _hoisted_52 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "font-weight-bold" }, "End Time", -1))
const _hoisted_53 = { class: "form-group" }
const _hoisted_54 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "font-weight-bold" }, "Duration", -1))
const _hoisted_55 = { class: "" }
const _hoisted_56 = { class: "row" }
const _hoisted_57 = { class: "form-group col" }
const _hoisted_58 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("small", { class: "form-text text-muted" }, "Hour(s)", -1))
const _hoisted_59 = {
  key: 1,
  class: "requiredTxt"
}
const _hoisted_60 = {
  key: 3,
  class: "requiredTxt"
}
const _hoisted_61 = { class: "form-group col" }
const _hoisted_62 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("small", { class: "form-text text-muted" }, "Minute(s)", -1))
const _hoisted_63 = {
  key: 1,
  class: "requiredTxt"
}
const _hoisted_64 = {
  key: 3,
  class: "requiredTxt"
}
const _hoisted_65 = { class: "col" }
const _hoisted_66 = { class: "row" }
const _hoisted_67 = { class: "col" }
const _hoisted_68 = { class: "form-group" }
const _hoisted_69 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "font-weight-bold" }, "Charge", -1))
const _hoisted_70 = { class: "form-check form-check-inline" }
const _hoisted_71 = { class: "form-check-label" }
const _hoisted_72 = ["disabled"]
const _hoisted_73 = { class: "form-check form-check-inline" }
const _hoisted_74 = { class: "form-check-label" }
const _hoisted_75 = ["disabled"]
const _hoisted_76 = { class: "col" }
const _hoisted_77 = { class: "form-group" }
const _hoisted_78 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "font-weight-bold" }, "Float", -1))
const _hoisted_79 = { class: "form-check form-check-inline" }
const _hoisted_80 = { class: "form-check-label" }
const _hoisted_81 = ["disabled"]
const _hoisted_82 = { class: "form-check form-check-inline" }
const _hoisted_83 = { class: "form-check-label" }
const _hoisted_84 = ["disabled"]
const _hoisted_85 = { class: "row" }
const _hoisted_86 = { class: "col-6" }
const _hoisted_87 = { class: "form-group" }
const _hoisted_88 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "font-weight-bold" }, "Cancellation Reason", -1))
const _hoisted_89 = ["value"]
const _hoisted_90 = {
  key: 1,
  class: "requiredTxt"
}
const _hoisted_91 = { class: "col" }
const _hoisted_92 = { class: "form-group" }
const _hoisted_93 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "font-weight-bold" }, "Unscheduled Absence", -1))
const _hoisted_94 = ["value"]
const _hoisted_95 = {
  key: 0,
  class: "row"
}
const _hoisted_96 = { class: "col-sm" }
const _hoisted_97 = { class: "form-group" }
const _hoisted_98 = { id: "gridPTOBalance" }
const _hoisted_99 = { class: "row" }
const _hoisted_100 = { class: "col-sm" }
const _hoisted_101 = { class: "form-group" }
const _hoisted_102 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "font-weight-bold" }, "Note", -1))
const _hoisted_103 = { class: "form-text text-muted" }
const _hoisted_104 = {
  key: 0,
  class: "requiredNoteControl material-icons",
  "aria-hidden": "true"
}
const _hoisted_105 = {
  key: 1,
  class: "requiredTxt"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_font_awesome_icon = _resolveComponent("font-awesome-icon")!
  const _component_neu_button = _resolveComponent("neu-button")!
  const _component_neu_icon = _resolveComponent("neu-icon")!
  const _component_neu_input = _resolveComponent("neu-input")!
  const _component_Datepicker = _resolveComponent("Datepicker")!
  const _component_vue_timepicker = _resolveComponent("vue-timepicker")!
  const _component_PTOBalance = _resolveComponent("PTOBalance")!
  const _component_neu_textarea = _resolveComponent("neu-textarea")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _withDirectives(_createElementVNode("legend", null, [
      _createElementVNode("span", { innerHTML: _ctx.Title }, null, 8, _hoisted_1)
    ], 512), [
      [_vShow, _ctx.showTitle]
    ]),
    _createElementVNode("div", _hoisted_2, [
      _withDirectives(_createElementVNode("span", _hoisted_3, "* Unsaved Changes *", 512), [
        [_vShow, _ctx.isChanged]
      ]),
      _withDirectives(_createVNode(_component_neu_button, {
        type: "button",
        fill: "raised",
        id: "reset_btn",
        onClick: _ctx.formOnReset
      }, {
        default: _withCtx(() => [
          _createVNode(_component_font_awesome_icon, {
            icon: ['fas', 'redo'],
            size: "sm",
            class: "mr-2"
          }),
          _createTextVNode(" Reset ")
        ]),
        _: 1
      }, 8, ["onClick"]), [
        [_vShow, _ctx.isChanged]
      ])
    ]),
    _createElementVNode("div", _hoisted_4, [
      _createElementVNode("div", _hoisted_5, [
        _createElementVNode("div", _hoisted_6, [
          _createElementVNode("div", _hoisted_7, [
            _createElementVNode("div", _hoisted_8, [
              _hoisted_9,
              _withDirectives(_createElementVNode("select", {
                class: _normalizeClass(["neu-select", [_ctx.isMoveDisabled ? 'readOnly' : '', _ctx.isFacilityRequired ? 'hasError' : '']]),
                name: "facility",
                "data-role": "dropdownlist",
                "data-option-label": "Select a Facility",
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.FacilityId) = $event)),
                disabled: _ctx.isMoveDisabled,
                onChange: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.facilitiesOnChange && _ctx.facilitiesOnChange(...args)))
              }, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.facilities, (fac) => {
                  return (_openBlock(), _createElementBlock("option", {
                    value: fac.value,
                    key: fac.value
                  }, _toDisplayString(fac.text), 9, _hoisted_11))
                }), 128))
              ], 42, _hoisted_10), [
                [_vModelSelect, _ctx.FacilityId]
              ]),
              _createVNode(_component_neu_icon, { class: "material-icons neu-input__select-icon z-max" }, {
                default: _withCtx(() => [
                  _createTextVNode("arrow_drop_down")
                ]),
                _: 1
              }),
              (_ctx.isFacilityRequired)
                ? (_openBlock(), _createBlock(_component_neu_icon, {
                    key: 0,
                    class: "requiredControl material-icons",
                    "aria-hidden": "true"
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode("error")
                    ]),
                    _: 1
                  }))
                : _createCommentVNode("", true),
              (_ctx.isFacilityRequired)
                ? (_openBlock(), _createElementBlock("span", _hoisted_12, "Required"))
                : _createCommentVNode("", true)
            ])
          ]),
          _createElementVNode("div", _hoisted_13, [
            _createElementVNode("div", _hoisted_14, [
              _hoisted_15,
              _createVNode(_component_neu_input, {
                name: "clusterName",
                readonly: "",
                disabled: "",
                modelValue: _ctx.ClusterName,
                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.ClusterName) = $event))
              }, null, 8, ["modelValue"])
            ])
          ]),
          _createElementVNode("div", _hoisted_16, [
            _createElementVNode("div", _hoisted_17, [
              _hoisted_18,
              _withDirectives(_createElementVNode("select", {
                class: _normalizeClass(["neu-select", [_ctx.isMoveDisabled ? 'readOnly' : '', _ctx.isDepartmentRequired ? 'hasError' : '']]),
                name: "department",
                "data-role": "dropdownlist",
                "data-option-label": "Select a Department",
                "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.DepartmentId) = $event)),
                disabled: _ctx.isMoveDisabled,
                onChange: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.departmentsOnChange && _ctx.departmentsOnChange(...args)))
              }, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.departments, (dept) => {
                  return (_openBlock(), _createElementBlock("option", {
                    value: dept.value,
                    key: dept.value
                  }, _toDisplayString(dept.text), 9, _hoisted_20))
                }), 128))
              ], 42, _hoisted_19), [
                [_vModelSelect, _ctx.DepartmentId]
              ]),
              _createVNode(_component_neu_icon, { class: "material-icons neu-input__select-icon z-max" }, {
                default: _withCtx(() => [
                  _createTextVNode("arrow_drop_down")
                ]),
                _: 1
              }),
              (_ctx.isDepartmentRequired)
                ? (_openBlock(), _createBlock(_component_neu_icon, {
                    key: 0,
                    class: "requiredControl material-icons",
                    "aria-hidden": "true"
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode("error")
                    ]),
                    _: 1
                  }))
                : _createCommentVNode("", true),
              (_ctx.isDepartmentRequired)
                ? (_openBlock(), _createElementBlock("span", _hoisted_21, "Required"))
                : _createCommentVNode("", true)
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_22, [
          _createElementVNode("div", _hoisted_23, [
            _createElementVNode("div", _hoisted_24, [
              _hoisted_25,
              _withDirectives(_createElementVNode("select", {
                class: _normalizeClass(["neu-select", [_ctx.isProductiveTypeRequired ? 'hasError' : '']]),
                name: "shifttype",
                "data-role": "dropdownlist",
                "data-option-label": "Select a Productive Type",
                "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.DropDownProductiveId) = $event)),
                onChange: _cache[6] || (_cache[6] = 
//@ts-ignore
(...args) => (_ctx.productiveCodesOnChange && _ctx.productiveCodesOnChange(...args)))
              }, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.productiveCodes, (code) => {
                  return (_openBlock(), _createElementBlock("option", {
                    value: code.fsProductiveID,
                    key: code.fsProductiveID
                  }, _toDisplayString(code.Description), 9, _hoisted_26))
                }), 128))
              ], 34), [
                [_vModelSelect, _ctx.DropDownProductiveId]
              ]),
              _createVNode(_component_neu_icon, { class: "material-icons neu-input__select-icon z-max" }, {
                default: _withCtx(() => [
                  _createTextVNode("arrow_drop_down")
                ]),
                _: 1
              }),
              (_ctx.isProductiveTypeRequired)
                ? (_openBlock(), _createBlock(_component_neu_icon, {
                    key: 0,
                    class: "requiredControl material-icons",
                    "aria-hidden": "true"
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode("error")
                    ]),
                    _: 1
                  }))
                : _createCommentVNode("", true),
              (_ctx.isProductiveTypeRequired)
                ? (_openBlock(), _createElementBlock("span", _hoisted_27, "Required"))
                : _createCommentVNode("", true)
            ])
          ]),
          _createElementVNode("div", _hoisted_28, [
            _createElementVNode("div", _hoisted_29, [
              _hoisted_30,
              _withDirectives(_createElementVNode("select", {
                class: _normalizeClass(["neu-select", [_ctx.isCancelled ? 'readOnly' : '', _ctx.isShiftCodeRequired ? 'hasError' : '']]),
                name: "shiftcode",
                "data-role": "dropdownlist",
                "data-option-label": "Select a Shift Code",
                "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.DepartmentShiftId) = $event)),
                disabled: _ctx.isCancelled,
                onChange: _cache[8] || (_cache[8] = 
//@ts-ignore
(...args) => (_ctx.shiftCodesOnChange && _ctx.shiftCodesOnChange(...args)))
              }, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.shiftCodes, (code) => {
                  return (_openBlock(), _createElementBlock("option", {
                    value: code.deptShiftId,
                    key: code.deptShiftId
                  }, _toDisplayString(code.deptShiftDescription), 9, _hoisted_32))
                }), 128))
              ], 42, _hoisted_31), [
                [_vModelSelect, _ctx.DepartmentShiftId]
              ]),
              _createVNode(_component_neu_icon, { class: "material-icons neu-input__select-icon z-max" }, {
                default: _withCtx(() => [
                  _createTextVNode("arrow_drop_down")
                ]),
                _: 1
              }),
              (_ctx.isShiftCodeRequired)
                ? (_openBlock(), _createBlock(_component_neu_icon, {
                    key: 0,
                    class: "requiredControl material-icons",
                    "aria-hidden": "true"
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode("error")
                    ]),
                    _: 1
                  }))
                : _createCommentVNode("", true),
              (_ctx.isShiftCodeRequired)
                ? (_openBlock(), _createElementBlock("span", _hoisted_33, "Required"))
                : _createCommentVNode("", true)
            ])
          ]),
          _createElementVNode("div", _hoisted_34, [
            _createElementVNode("div", _hoisted_35, [
              _hoisted_36,
              _withDirectives(_createElementVNode("select", {
                class: _normalizeClass(["neu-select", [_ctx.isCancelled ? 'readOnly' : '', _ctx.isSkillRequired ? 'hasError' : '']]),
                name: "skill",
                "data-role": "dropdownlist",
                "data-option-label": "Select a Skill",
                "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.SkillLevelID) = $event)),
                disabled: _ctx.isCancelled,
                onChange: _cache[10] || (_cache[10] = 
//@ts-ignore
(...args) => (_ctx.skillsOnChange && _ctx.skillsOnChange(...args)))
              }, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.skills, (skil) => {
                  return (_openBlock(), _createElementBlock("option", {
                    value: skil.SkillLevelID,
                    style: {"cursor":"pointer"},
                    key: skil.SkillLevelID,
                    class: _normalizeClass([!skil.isStaffSkill ? 'skill-color' : '']),
                    title: !skil.isStaffSkill ? 'Select temporary covering skill' : ''
                  }, _toDisplayString(skil.SkillDescription), 11, _hoisted_38))
                }), 128))
              ], 42, _hoisted_37), [
                [_vModelSelect, _ctx.SkillLevelID]
              ]),
              _createVNode(_component_neu_icon, { class: "material-icons neu-input__select-icon z-max" }, {
                default: _withCtx(() => [
                  _createTextVNode("arrow_drop_down")
                ]),
                _: 1
              }),
              (_ctx.isSkillRequired)
                ? (_openBlock(), _createBlock(_component_neu_icon, {
                    key: 0,
                    class: "requiredControl material-icons",
                    "aria-hidden": "true"
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode("error")
                    ]),
                    _: 1
                  }))
                : _createCommentVNode("", true),
              (_ctx.isSkillRequired)
                ? (_openBlock(), _createElementBlock("span", _hoisted_39, "Required"))
                : _createCommentVNode("", true),
              _withDirectives(_createElementVNode("span", _hoisted_40, [
                _createVNode(_component_font_awesome_icon, {
                  icon: ['fas', 'circle-exclamation'],
                  size: "sm",
                  class: "mr-2"
                }),
                _createTextVNode(" Selected skill is not assigned to department, please select another skill ")
              ], 512), [
                [_vShow, _ctx.invalidSkill]
              ])
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_41, [
          _createElementVNode("div", _hoisted_42, [
            _createElementVNode("div", _hoisted_43, [
              _hoisted_44,
              _createVNode(_component_Datepicker, {
                modelValue: _ctx.ShiftDate,
                "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.ShiftDate) = $event)),
                inputClassName: "dp-custom-input",
                weekStart: "0",
                enableTimePicker: false,
                class: _normalizeClass([_ctx.isSplit ? 'readOnly' : '']),
                disabled: _ctx.isSplit,
                onChange: _ctx.dateTimeOnChange,
                autoApply: ""
              }, null, 8, ["modelValue", "class", "disabled", "onChange"])
            ])
          ]),
          _createElementVNode("div", _hoisted_45, [
            _createElementVNode("div", _hoisted_46, [
              _createElementVNode("div", _hoisted_47, [
                _createElementVNode("div", _hoisted_48, [
                  _hoisted_49,
                  (_openBlock(), _createBlock(_component_vue_timepicker, {
                    format: "h:mm A",
                    name: "startTime",
                    modelValue: _ctx.ShiftStartTime,
                    "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((_ctx.ShiftStartTime) = $event)),
                    class: _normalizeClass([_ctx.isStandardShift ? 'readOnly' : '']),
                    disabled: _ctx.isStandardShift,
                    "minute-interval": _ctx.MinuteInterval,
                    "manual-input": _ctx.ManualInput,
                    key: _ctx.counterStartTime,
                    "auto-scroll": "",
                    "close-on-complete": "",
                    onBlur: _ctx.startTimeOnChange,
                    onChange: _ctx.startTimeOnChange
                  }, null, 8, ["modelValue", "class", "disabled", "minute-interval", "manual-input", "onBlur", "onChange"]))
                ])
              ]),
              _createElementVNode("div", _hoisted_50, [
                _createElementVNode("div", null, [
                  _withDirectives(_createElementVNode("div", _hoisted_51, [
                    _hoisted_52,
                    (_openBlock(), _createBlock(_component_vue_timepicker, {
                      format: "h:mm A",
                      name: "endTime",
                      modelValue: _ctx.ShiftEndTime,
                      "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((_ctx.ShiftEndTime) = $event)),
                      class: _normalizeClass([_ctx.isStandardShift ? 'readOnly' : '']),
                      disabled: _ctx.isStandardShift,
                      "minute-interval": _ctx.MinuteInterval,
                      "manual-input": _ctx.ManualInput,
                      key: _ctx.counterEndTime,
                      "auto-scroll": "",
                      "close-on-complete": "",
                      onBlur: _ctx.endTimeOnChange,
                      onChange: _ctx.endTimeOnChange
                    }, null, 8, ["modelValue", "class", "disabled", "minute-interval", "manual-input", "onBlur", "onChange"]))
                  ], 512), [
                    [_vShow, _ctx.showEndTime]
                  ])
                ]),
                _createElementVNode("div", null, [
                  _withDirectives(_createElementVNode("div", _hoisted_53, [
                    _hoisted_54,
                    _createElementVNode("div", _hoisted_55, [
                      _createElementVNode("div", _hoisted_56, [
                        _createElementVNode("div", _hoisted_57, [
                          _createVNode(_component_neu_input, {
                            name: "hours",
                            value: _ctx.DurationHours,
                            inputmode: "numeric",
                            type: "number",
                            max: 24,
                            min: 0,
                            class: _normalizeClass([_ctx.isDurationHoursRequired || _ctx.isDurationHoursInvalid ? 'hasError' : '']),
                            disabled: _ctx.isDurationDisabled,
                            onChange: _cache[14] || (_cache[14] = ($event: any) => (_ctx.OnChangeValueDateTime($event,'DurationHours')))
                          }, null, 8, ["value", "class", "disabled"]),
                          _hoisted_58,
                          (_ctx.isDurationHoursRequired)
                            ? (_openBlock(), _createBlock(_component_neu_icon, {
                                key: 0,
                                class: "requiredDurationControl material-icons",
                                "aria-hidden": "true"
                              }, {
                                default: _withCtx(() => [
                                  _createTextVNode("error")
                                ]),
                                _: 1
                              }))
                            : _createCommentVNode("", true),
                          (_ctx.isDurationHoursRequired)
                            ? (_openBlock(), _createElementBlock("span", _hoisted_59, "Required"))
                            : _createCommentVNode("", true),
                          (_ctx.isDurationHoursInvalid)
                            ? (_openBlock(), _createBlock(_component_neu_icon, {
                                key: 2,
                                class: "requiredDurationControl material-icons",
                                "aria-hidden": "true"
                              }, {
                                default: _withCtx(() => [
                                  _createTextVNode("error")
                                ]),
                                _: 1
                              }))
                            : _createCommentVNode("", true),
                          (_ctx.isDurationHoursInvalid)
                            ? (_openBlock(), _createElementBlock("span", _hoisted_60, "Invalid"))
                            : _createCommentVNode("", true)
                        ]),
                        _createElementVNode("div", _hoisted_61, [
                          _createVNode(_component_neu_input, {
                            name: "minutes",
                            value: _ctx.DurationMinutes,
                            inputmode: "numeric",
                            type: "number",
                            max: 60,
                            min: 0,
                            step: 15,
                            class: _normalizeClass([_ctx.isDurationMinutesRequired || _ctx.isDurationMinutesInvalid ? 'hasError' : '']),
                            disabled: _ctx.isDurationDisabled,
                            onChange: _cache[15] || (_cache[15] = ($event: any) => (_ctx.OnChangeValueDateTime($event,'DurationMinutes')))
                          }, null, 8, ["value", "class", "disabled"]),
                          _hoisted_62,
                          (_ctx.isDurationMinutesRequired)
                            ? (_openBlock(), _createBlock(_component_neu_icon, {
                                key: 0,
                                class: "requiredDurationControl material-icons",
                                "aria-hidden": "true"
                              }, {
                                default: _withCtx(() => [
                                  _createTextVNode("error")
                                ]),
                                _: 1
                              }))
                            : _createCommentVNode("", true),
                          (_ctx.isDurationMinutesRequired)
                            ? (_openBlock(), _createElementBlock("span", _hoisted_63, "Required"))
                            : _createCommentVNode("", true),
                          (_ctx.isDurationMinutesInvalid)
                            ? (_openBlock(), _createBlock(_component_neu_icon, {
                                key: 2,
                                class: "requiredDurationControl material-icons",
                                "aria-hidden": "true"
                              }, {
                                default: _withCtx(() => [
                                  _createTextVNode("error")
                                ]),
                                _: 1
                              }))
                            : _createCommentVNode("", true),
                          (_ctx.isDurationMinutesInvalid)
                            ? (_openBlock(), _createElementBlock("span", _hoisted_64, "Invalid"))
                            : _createCommentVNode("", true)
                        ])
                      ])
                    ])
                  ], 512), [
                    [_vShow, _ctx.showNonProductiveTime]
                  ])
                ])
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_65, [
            _createElementVNode("div", _hoisted_66, [
              _createElementVNode("div", _hoisted_67, [
                _createElementVNode("div", _hoisted_68, [
                  _hoisted_69,
                  _createElementVNode("div", null, [
                    _createElementVNode("div", _hoisted_70, [
                      _createElementVNode("label", _hoisted_71, [
                        _withDirectives(_createElementVNode("input", {
                          class: "form-check-input",
                          type: "radio",
                          id: "charge_yes",
                          name: "isCharge",
                          value: true,
                          "data-type": "boolean",
                          onChange: _cache[16] || (_cache[16] = 
//@ts-ignore
(...args) => (_ctx.OnChargeChange && _ctx.OnChargeChange(...args))),
                          "onUpdate:modelValue": _cache[17] || (_cache[17] = ($event: any) => ((_ctx.Charge) = $event)),
                          disabled: _ctx.isChargeDisabled
                        }, null, 40, _hoisted_72), [
                          [_vModelRadio, _ctx.Charge]
                        ]),
                        _createTextVNode(" Yes ")
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_73, [
                      _createElementVNode("label", _hoisted_74, [
                        _withDirectives(_createElementVNode("input", {
                          class: "form-check-input",
                          type: "radio",
                          id: "charge_no",
                          name: "isCharge",
                          value: false,
                          "data-type": "boolean",
                          onChange: _cache[18] || (_cache[18] = 
//@ts-ignore
(...args) => (_ctx.OnChargeChange && _ctx.OnChargeChange(...args))),
                          "onUpdate:modelValue": _cache[19] || (_cache[19] = ($event: any) => ((_ctx.Charge) = $event)),
                          disabled: _ctx.isChargeDisabled
                        }, null, 40, _hoisted_75), [
                          [_vModelRadio, _ctx.Charge]
                        ]),
                        _createTextVNode(" No ")
                      ])
                    ])
                  ])
                ])
              ]),
              _withDirectives(_createElementVNode("div", _hoisted_76, [
                _createElementVNode("div", _hoisted_77, [
                  _hoisted_78,
                  _createElementVNode("div", null, [
                    _createElementVNode("div", _hoisted_79, [
                      _createElementVNode("label", _hoisted_80, [
                        _withDirectives(_createElementVNode("input", {
                          class: "form-check-input",
                          type: "radio",
                          id: "float_yes",
                          name: "isFloat",
                          value: true,
                          "data-type": "boolean",
                          "onUpdate:modelValue": _cache[20] || (_cache[20] = ($event: any) => ((_ctx.IsFloat) = $event)),
                          disabled: _ctx.isFloatDisabled,
                          onChange: _cache[21] || (_cache[21] = 
//@ts-ignore
(...args) => (_ctx.floatSelection && _ctx.floatSelection(...args)))
                        }, null, 40, _hoisted_81), [
                          [_vModelRadio, _ctx.IsFloat]
                        ]),
                        _createTextVNode(" Yes ")
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_82, [
                      _createElementVNode("label", _hoisted_83, [
                        _withDirectives(_createElementVNode("input", {
                          class: "form-check-input",
                          type: "radio",
                          id: "float_no",
                          name: "isFloat",
                          value: false,
                          "data-type": "boolean",
                          "onUpdate:modelValue": _cache[22] || (_cache[22] = ($event: any) => ((_ctx.IsFloat) = $event)),
                          disabled: _ctx.isFloatDisabled,
                          onChange: _cache[23] || (_cache[23] = 
//@ts-ignore
(...args) => (_ctx.floatSelection && _ctx.floatSelection(...args)))
                        }, null, 40, _hoisted_84), [
                          [_vModelRadio, _ctx.IsFloat]
                        ]),
                        _createTextVNode(" No ")
                      ])
                    ])
                  ])
                ])
              ], 512), [
                [_vShow, _ctx.isFloatVisible]
              ])
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_85, [
          _withDirectives(_createElementVNode("div", _hoisted_86, [
            _createElementVNode("div", _hoisted_87, [
              _hoisted_88,
              _withDirectives(_createElementVNode("select", {
                class: _normalizeClass(["neu-select", [_ctx.isCancelReasonsRequired ? 'hasError' : '']]),
                name: "cancelReason",
                "data-role": "dropdownlist",
                "onUpdate:modelValue": _cache[24] || (_cache[24] = ($event: any) => ((_ctx.CancelReasonId) = $event)),
                onChange: _cache[25] || (_cache[25] = 
//@ts-ignore
(...args) => (_ctx.cancelReasonsOnChange && _ctx.cancelReasonsOnChange(...args)))
              }, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.cancelReasons, (reason) => {
                  return (_openBlock(), _createElementBlock("option", {
                    value: reason.reasonId,
                    key: reason.reasonId
                  }, _toDisplayString(reason.reason), 9, _hoisted_89))
                }), 128))
              ], 34), [
                [_vModelSelect, _ctx.CancelReasonId]
              ]),
              _createVNode(_component_neu_icon, { class: "material-icons neu-input__select-icon z-max" }, {
                default: _withCtx(() => [
                  _createTextVNode("arrow_drop_down")
                ]),
                _: 1
              }),
              (_ctx.isCancelReasonsRequired)
                ? (_openBlock(), _createBlock(_component_neu_icon, {
                    key: 0,
                    class: "requiredCancelRsnControl material-icons",
                    "aria-hidden": "true"
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode("error")
                    ]),
                    _: 1
                  }))
                : _createCommentVNode("", true),
              (_ctx.isCancelReasonsRequired)
                ? (_openBlock(), _createElementBlock("span", _hoisted_90, "Required"))
                : _createCommentVNode("", true)
            ])
          ], 512), [
            [_vShow, _ctx.showCancelOptions]
          ]),
          _withDirectives(_createElementVNode("div", _hoisted_91, [
            _createElementVNode("div", _hoisted_92, [
              _hoisted_93,
              _withDirectives(_createElementVNode("select", {
                class: "neu-select",
                name: "unscheduledAbsence",
                "data-role": "dropdownlist",
                "onUpdate:modelValue": _cache[26] || (_cache[26] = ($event: any) => ((_ctx.UnscheduledAbsenceOptionId) = $event)),
                onChange: _cache[27] || (_cache[27] = 
//@ts-ignore
(...args) => (_ctx.uaOptionsOnChange && _ctx.uaOptionsOnChange(...args)))
              }, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.uaOptions, (uao) => {
                  return (_openBlock(), _createElementBlock("option", {
                    value: uao.value,
                    key: uao.value
                  }, _toDisplayString(uao.text), 9, _hoisted_94))
                }), 128))
              ], 544), [
                [_vModelSelect, _ctx.UnscheduledAbsenceOptionId]
              ]),
              _createVNode(_component_neu_icon, { class: "material-icons neu-input__select-icon z-max" }, {
                default: _withCtx(() => [
                  _createTextVNode("arrow_drop_down")
                ]),
                _: 1
              })
            ])
          ], 512), [
            [_vShow, _ctx.showUnscheduledOptions]
          ])
        ]),
        (_ctx.isloadPTOBalance)
          ? (_openBlock(), _createElementBlock("div", _hoisted_95, [
              _createElementVNode("div", _hoisted_96, [
                _createElementVNode("div", _hoisted_97, [
                  _createElementVNode("div", _hoisted_98, [
                    _createVNode(_component_PTOBalance, {
                      StaffId: _ctx.staffIdPTO,
                      ShiftDate: _ctx.shiftDatePTO
                    }, null, 8, ["StaffId", "ShiftDate"])
                  ])
                ])
              ])
            ]))
          : _createCommentVNode("", true)
      ])
    ]),
    _createElementVNode("div", _hoisted_99, [
      _createElementVNode("div", _hoisted_100, [
        _createElementVNode("div", _hoisted_101, [
          _hoisted_102,
          _createVNode(_component_neu_textarea, {
            rows: "4",
            maxlength: "500",
            placeholder: "Add an assignment note.",
            name: "note",
            modelValue: _ctx.Note,
            "onUpdate:modelValue": _cache[28] || (_cache[28] = ($event: any) => ((_ctx.Note) = $event)),
            class: _normalizeClass([_ctx.isNoteTxtRequired ? 'hasError' : '']),
            onKeyup: _ctx.noteOnChange
          }, null, 8, ["modelValue", "class", "onKeyup"]),
          _createElementVNode("small", _hoisted_103, [
            _createTextVNode("Remaining "),
            _createElementVNode("span", null, _toDisplayString(_ctx.NoteMaxLength - (_ctx.Note != undefined && _ctx.Note != "" &&
                    _ctx.Note != null ? _ctx.Note.length : 0)), 1),
            _createTextVNode("/"),
            _createElementVNode("span", null, _toDisplayString(_ctx.NoteMaxLength), 1)
          ]),
          (_ctx.isNoteTxtRequired)
            ? (_openBlock(), _createElementBlock("span", _hoisted_104, "error"))
            : _createCommentVNode("", true),
          (_ctx.isNoteTxtRequired)
            ? (_openBlock(), _createElementBlock("span", _hoisted_105, "Required"))
            : _createCommentVNode("", true)
        ])
      ])
    ])
  ], 64))
}